import React from "react";
import { connect } from "react-redux";
import { Topic } from "../Models/Topic";
import { IAppState } from "../../Common";

type StateProps = {
  activeTopic?: Topic;
};

const mapStateToProps = (state: IAppState): StateProps => ({
  activeTopic: state.app.activeTopic
});

const ActiveTopicName: React.FC<StateProps> = props => (
  <>
    {!!props.activeTopic && <span>{props.activeTopic.name}</span>}
    {!props.activeTopic && <span>(No Topic Selected)</span>}
  </>
);

export default connect(mapStateToProps)(ActiveTopicName);
